import { render, staticRenderFns } from "./EntityDetailsModal.vue?vue&type=template&id=b0f2c67e&scoped=true&"
import script from "./EntityDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EntityDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./EntityDetailsModal.vue?vue&type=style&index=0&id=b0f2c67e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f2c67e",
  null
  
)

export default component.exports